module.exports = __webpack_public_path__ + "img/LR-anwendungsgebiete_STAERKUNGHERZKREISLAUF_hauptseite-hintergrund.d83d6c89.jpg";